import React, { useState } from "react"
import { Container, Modal } from "reactstrap"
import AccessDenieds from "../assets/images/404.gif"
import { useNavigate } from "react-router-dom"
import HorizontalLayout from "components/HorizontalLayout"
import Configs from "../config"

const AccessDenied = () => {
  const [modal_Access, setAccessDenied] = useState(true)
  document.title = "Access Denied"

  const navigate = useNavigate()
  return (
    <div>
      <div>
        <HorizontalLayout>
          <div className="page-content">
            <Container fluid>
              <div className="text-center w-100 bg-white">
                <img src={AccessDenieds} className="" height="530" />
                <div style={{ marginTop: "-70px" }}>
                  <h1>Page Not Found ...</h1>
                  <p>Or You don't have Permissions to access this page.</p>
                  <div className="pb-4">
                    {" "}
                    <button
                      type="button"
                      className="btn btn-blue text-white fs-6"
                      onClick={() => navigate(`${Configs.appurl}`)}
                    >
                      I Understood
                      <i className="dripicons-thumbs-up pl-10"></i>
                    </button>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </HorizontalLayout>
      </div>
    </div>
  )
}

export default AccessDenied
